module.exports = __webpack_public_path__ + "static/media/chicken-food-gastronomy-svgrepo-com.7cf49ce1.svg";